<template lang='pug'>
    el-dialog.modal-inibir-restricoes(
        :visible.sync='mostrarDialog',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        width='30%'
    )
        div(
            style='background: white; height: auto; padding: 20px; border-radius: 5px'
        )
            section.mb-4.template(slot='title')
                .modal-inibir-restricoes__header
                    .modal-inibir-restricoes__header--icon
                        i.el-icon-edit
                    .modal-inibir-restricoes__header--title
                        | {{ $t('mensagens.operacao.monitoramento.editarRestricoes') }}

            section.modal-inibir-restricoes__body
                .modal-inibir-restricoes__body--descricao
                    div(v-html='identificarLabelRestricoes()')

                    .modal-inibir-restricoes__body--form
                        el-form(
                            label-position='top',
                            ref='formInibirRestricoes',
                            :model='payload',
                            :rules='formRules'
                        )
                            el-form-item(
                                prop='operacoes',
                                v-if='this.operacoes.length > 0'
                            )
                                template(slot='label')
                                    span.label {{ $t('mensagens.operacao.monitoramento.selecionarOperacoes') }}
                                el-checkbox(v-model='selecionarTodas' @change='alterarCheckbox()') {{ $t('mensagens.operacao.monitoramento.selecionarTodas') }}
                                el-select.w-100(
                                    v-model='payload.idsOperacoes',
                                    multiple,
                                    filterable,
                                    collapse-tags,
                                    :placeholder="$t('mensagens.operacao.monitoramento.cliqueSelecionar')",
                                    value-key='id',
                                    @change='verificarCheckbox()'
                                )
                                    el-option(
                                        v-for='operacao in operacoes',
                                        :key='operacao.id',
                                        :label='montarLabelOpcoes(operacao)',
                                        :value='operacao.id'
                                    )

                            el-form-item(prop='justificativa')
                                template(slot='label')
                                    span.label.campo_obrigatorio {{ $t('mensagens.operacao.monitoramento.selecionarJustificativa') }}
                                el-select.w-100(
                                    v-model='payload.idJustificativa',
                                    :placeholder="$t('mensagens.operacao.monitoramento.cliqueSelecionar')",
                                    value-key='id'
                                )
                                    el-option(
                                        v-for='justificativa in justificativas',
                                        :key='justificativa.id',
                                        :label='justificativa.nome',
                                        :value='justificativa.id'
                                    )

                            el-form-item(prop='descricao')
                                template(slot='label')
                                    span.label {{ $t('mensagens.operacao.formularioGeral.descricao') }}

                                el-input(
                                    v-model='payload.descricaoJustificativa',
                                    type='textarea',
                                    :rows='3',
                                    :placeholder="$t('mensagens.operacao.monitoramento.digiteJustificativa')"
                                )

            section.modal-inibir-restricoes__action
                BaseButton(size='mini', @click='fechar')
                    | {{ $t('mensagens.comuns.voltar') }}
                BaseButton(type='primary', size='mini', @click='editarRestricao')
                    | {{ $t('mensagens.comuns.salvar') }}
</template>

<script>
import OperacaoMonitoramentoService from '@/services/OperacaoMonitoramentoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalEdicaoRestricoes',

    components: {
        BaseButton
    },

    props: {
        idOperacao: {
            required: true
        },
        codigoCamada: {
            type: String,
            required: true
        },
        codigoRestricao: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            mostrarDialog: false,
            selecionarTodas: false,
            payload: {
                codigoCamada: null,
                codigoRestricao: null,
                idsOperacoes: [],
                idJustificativa: null,
                descricaoJustificativa: null
            },
            formRules: {
                justificativa: [
                    { validator: this.checkRuleJustificativa, trigger: 'blur' }
                ],
                descricao: [
                    { validator: this.checkRuleDescricao, trigger: 'blur' }
                ]
            },
            operacoes: [],
            justificativas: []
        };
    },

    watch: {
        mostrarDialog: function(value) {
            if (value) {
                this.payload.codigoCamada = this.codigoCamada;
                this.payload.codigoRestricao = this.codigoRestricao;
                this.buscarJustificativas();
                this.buscarDadosInibicao();
            }
        }
    },

    mounted () {
        this.verificarCheckbox();
    },

    methods: {
        async buscarDadosInibicao() {
            await OperacaoMonitoramentoService.buscarDadosInibicao({
                idOperacao: this.idOperacao,
                codigoRestricao: this.codigoRestricao
            })
                .then(({ data }) => {
                    this.payload.idJustificativa = data.idJustificativa;
                    this.payload.descricaoJustificativa = data.descricao;
                    this.payload.idsOperacoes = data.operacoesSelecionadas;
                    this.operacoes = data.operacoes;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.erroInibicaoRestricao')
                    })
                );
        },
        async buscarJustificativas() {
            await OperacaoMonitoramentoService.buscarJustificativasInibirRestricoes()
                .then(({ data }) => {
                    this.justificativas = data.itens;
                })
                .catch(() => {
                        this.$notify.error({
                            message:
                                this.$t('mensagens.operacao.notificacao.erroEdicaoInibicaoJustificativa')
                        });
                        this.fechar();
                    }
                );
        },
        checkRuleJustificativa(rule, value, callback) {
            if (this.payload.idJustificativa === null) {
                return callback(
                    new Error(this.$t('mensagens.operacao.notificacao.justificativaMinima'))
                );
            }
            callback();
        },
        checkRuleDescricao(rule, value, callback) {
            if (this.payload.descricaoJustificativa?.length > 1000) {
                return callback(
                    new Error(this.$t('mensagens.operacao.notificacao.descricaoExcessiva'))
                );
            }
            callback();
        },
        async editarRestricao() {
            const formValidado = await this.$refs.formInibirRestricoes
                .validate()
                .then(value => value)
                .catch(() => false);

            if (!formValidado) return;

            this.payload.idsOperacoes.push(this.idOperacao);
            await OperacaoMonitoramentoService.editarRestricao(this.payload)
                .then(({ data }) => {
                    this.$notify.success({
                        message: data,
                        duration: 10000
                    });
                    this.fechar();
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.editarRestricaoSuporte') +
                            this.$t('mensagens.operacao.notificacao.inibirRestricaoSuporte2')
                    });
                    this.fechar();
                })
                .finally(() => {
                    this.payload = {
                        codigoCamada: null,
                        codigoRestricao: null,
                        idsOperacoes: [],
                        idJustificativa: null,
                        descricaoJustificativa: null
                    };
                });
        },
        alterarCheckbox () {
            this.payload.idsOperacoes = [];
            if (this.selecionarTodas) {
                this.operacoes.forEach(operacao => {
                    this.payload.idsOperacoes.push(operacao.id);
                });
            }
        },
        verificarCheckbox () {
            if (this.payload.idsOperacoes.length === this.operacoes.length) {
                this.selecionarTodas = true;
            } else {
                this.selecionarTodas = false;
            }
        },
        identificarLabelRestricoes() {
            if (this.operacoes.length > 0) {
                return `<span>${this.$t('mensagens.operacao.monitoramento.editarLabelRestricoes1')} ${this.operacoes.length} ${this.$t('mensagens.operacao.monitoramento.editarLabelRestricoes2')}
                        ${this.$t('mensagens.operacao.monitoramento.editarLabelRestricoes3')} <b>${this.$t('mensagens.operacao.monitoramento.editarLabelRestricoes4')}</b> ${this.$t('mensagens.operacao.monitoramento.editarLabelRestricoes5')}</span>`;
            } else {
                return `<span>${this.$t('mensagens.operacao.monitoramento.editarLabelRestricoes6')} <b>${this.$t('mensagens.operacao.monitoramento.editarLabelRestricoes7')}</b> ${this.$t('mensagens.operacao.monitoramento.editarLabelRestricoes8')}</span>`;
            }
        },
        montarLabelOpcoes(operacao) {
            return this.$t('mensagens.operacao.monitoramento.id') + ': ' + operacao.identificador + ' | ' + this.$t('mensagens.operacao.tabela.nome') + ': ' + (operacao.nome ? operacao.nome : '--');
        },
        fechar() {
            this.selecionarTodas = false;
            this.mostrarDialog = false;
            this.payload = {
                codigoCamada: null,
                codigoRestricao: null,
                idsOperacoes: [],
                idJustificativa: null,
                descricaoJustificativa: null
            };
        }
    }
};
</script>

<style lang='scss'>
.modal-inibir-restricoes {
    display: flex;

    .modal-inibir-restricoes__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .modal-inibir-restricoes__header--icon {
            margin-right: 10px;
            font-size: 20px;
            color: #fec556;
        }

        .modal-inibir-restricoes__header--title {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .modal-inibir-restricoes__body {
        width: 100%;

        .modal-inibir-restricoes__body--descricao {
            font-weight: 500;
            font-size: 14px;
            word-break: break-word;
        }
    }

    .modal-inibir-restricoes__action {
        height: 50px;
        border-top: solid 2px #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .el-dialog {
        background: none !important;
    }

    .el-dialog__body {
        padding: 20px;
    }

    .el-form-item__label {
        padding: 0 !important;
        margin-top: 5px !important;
    }

    .campo_obrigatorio::after {
        content: '*';
        color: red;
    }
}
</style>
